const prepareHeaderScript = (
  code: string
) => `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${code}');`;

const prepareFooterScript = (
  code: string
) => `<iframe src="https://www.googletagmanager.com/ns.html?id=${code}"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const addScriptToElement = (code: string) => {
  let header = document.getElementsByTagName("head");
  let header_script = document.createElement("script");
  header_script.type = "text/javascript";
  header_script.async = true;

  let body = document.getElementsByTagName("body");
  let body_script = document.createElement("noscript");

  header_script.innerHTML = prepareHeaderScript(code);
  body_script.innerHTML = prepareFooterScript(code);

  header[0].appendChild(header_script);
  body[0].appendChild(body_script);
};

export const addGoogleTagManager = () => {
  try {
    let host = window.location.hostname;
    if (host.includes("apac")) {
      // APAC env
      if (host.includes("play")) {
        addScriptToElement(`GTM-${process.env.GOOGLE_TAG_ID_PLAY_APAC}`);
      } else {
        addScriptToElement(`GTM-${process.env.GOOGLE_TAG_ID_APAC}`);
      }
    }

    if (host.startsWith("app.") || host.startsWith("fleetlogic.")) {
      // NA env
      addScriptToElement(`GTM-${process.env.GOOGLE_TAG_ID_NA}`);
    }

    if (host.startsWith("play.")) {
      // NA play
      addScriptToElement(`GTM-${process.env.GOOGLE_TAG_ID_PLAY_NA}`);
    }
  } catch (e) {
    console.log(e);
  }
};
